import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StatusCandidato } from '../../../models/statusCandidato';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { CandidatoService } from '../../candidato/candidato.service';
import { Util } from '../../shared/util';

@Component({
  templateUrl: './gerenciar-exame-toxicologico.component.html'
})
export class GerenciarExameToxicologicoComponent extends WebPage implements OnInit {

  idCandidato;
  candidato;
  listaHistoricoExameToxicologico: any[];

  constructor(
    private route: ActivatedRoute,
    private candidatoService: CandidatoService, private arquivoService: ArquivoService,
    messageService: MessageService
  ) {
    super(messageService);

    this.route.paramMap.subscribe(params =>
      this.idCandidato = params.get('idCandidato')
    );
  }

  ngOnInit() {
    this.isLoading = true;
    this.candidatoService.getFull(this.idCandidato)
      .finally(() => this.isLoading = false)
      .subscribe(
        candidato => {
          this.candidato = candidato;
          this.listaHistoricoExameToxicologico =
            candidato.candidatoHistorico
            .filter(this.getHistoricoExameToxicologico)
            .sort(this.ordenaHistoricosPorData);
        },
        error => this.gerenciaErro(error)
      );
  }

  getHistoricoExameToxicologico(historico) {
    return historico.idStatusCandidato.toLowerCase() === StatusCandidato.EncaminhadoRealizacaoExameToxicologico.toLowerCase()
    || historico.idStatusCandidato.toLowerCase() === StatusCandidato.ClassificadoExameToxicologico.toLowerCase()
    || historico.idStatusCandidato.toLowerCase() === StatusCandidato.DesclassificadoExameToxicologico.toLowerCase();
  }

  ordenaHistoricosPorData(historico1, historico2) {
    return historico1.dataRegistro > historico2.dataRegistro ? -1 : historico1.dataRegistro < historico2.dataRegistro ? 1 : 0;
  }

  getNomeEvento(idStatusCandidato) {
    return (idStatusCandidato.toLowerCase() === StatusCandidato.EncaminhadoRealizacaoExameToxicologico.toLowerCase())
      ? 'Solicitação de Exame Toxicológico'
      : 'Resultado do Exame Toxicológico';
  }

  getResultado(idStatusCandidato) {
    if (idStatusCandidato.toLowerCase() === StatusCandidato.EncaminhadoRealizacaoExameToxicologico.toLowerCase()) {
      return '-';
    }

    return (idStatusCandidato.toLowerCase() === StatusCandidato.ClassificadoExameToxicologico.toLowerCase())
      ? 'Aprovado'
      : 'Reprovado';
  }

  downloadResultado(idArquivo) {
    this.arquivoService.downloadArquivo(idArquivo, 'Resultado_exame');
  }

  podeMostrarBotaoCadastroResultados() {
    if (Util.isNullOrEmptyOrUndefined(this.candidato)) {
      return false;
    }

    const idStatusCandidato = this.candidato.idStatusCandidato.toUpperCase();
    return idStatusCandidato === StatusCandidato.EncaminhadoRealizacaoExameToxicologico
      || idStatusCandidato === StatusCandidato.DesclassificadoExameToxicologico;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/exameToxicologico/gerenciar-exame-toxicologico/gerenciar-exame-toxicologico.component.ts